import { FC, useEffect } from 'react'
import { IoExpandOutline, IoLogoAndroid, IoLogoApple } from 'react-icons/io5'
import { useTranslation } from 'react-i18next'
import { STORE_LINKS } from '@expane/logic/links/mobile'

export const MobilePage: FC = () => {
  const { t } = useTranslation()

  useEffect(() => {
    // Detect device type
    const userAgent = navigator.userAgent
    const isIOS = /iPad|iPhone|iPod/.test(userAgent)
    const isAndroid = /android/i.test(userAgent)

    if (isIOS || isAndroid) {
      // Store URL to redirect to if app doesn't open
      const storeUrl = isIOS ? STORE_LINKS.ios.app : STORE_LINKS.android.app

      // Set a timeout to redirect to the app store if the app doesn't open
      const timeout = setTimeout(() => {
        window.location.href = storeUrl
      }, 50)

      // Clear the timeout if the page is hidden (app opened successfully)
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          clearTimeout(timeout)
        }
      })
    }
  }, [])

  return (
    <div className="w-screen h-screen flex flex-col justify-center items-center px-8 text-center">
      <IoExpandOutline size="8rem" className="text-primary-700" />
      <p className="mt-8 mb-2 text-main-color text-lg font-medium">
        {t('mobilePage.screenIsTooSmall')}
      </p>
      <p className="text-secondary-color">{t('mobilePage.options')}:</p>

      <div className="flex justify-center gap-8 my-8">
        <a href={STORE_LINKS.ios.app} className={linkStyle}>
          <IoLogoApple size="1.6rem" />
          App store
        </a>

        <a href={STORE_LINKS.android.app} className={linkStyle}>
          <IoLogoAndroid size="1.6rem" />
          Google Play
        </a>
      </div>
    </div>
  )
}

const linkStyle =
  'flex gap-1 items-center justify-center text-secondary-color hover:text-gray-500 hover:dark:text-gray-300 focus:text-gray-500 focus:dark:text-gray-300 text-xl underline'
